<template>
  <div class="create-product-group-desc-modal" v-click-outside="closeModal">
    <div class="header">
      <h2>{{ $t("productGroup.createProductGroupDescModal.title") }}</h2>
    </div>

    <div class="content">
      <v-select
        v-model="selectedLanguage"
        :items="availableLanguages"
        variant="outlined"
        item-title="title"
        item-value="id"
      ></v-select>
      <v-textarea
        id="message"
        name="message"
        autocomplete="off"
        variant="plain"
        v-model="description"
        type="text"
        no-resize
        placeholder="Leírás"
        class="message"
        rows="8"
      ></v-textarea>
    </div>

    <div class="button-row">
      <v-btn :disabled="isLoading" @click="closeModal">
        {{ $t("productGroup.createProductGroupDescModal.buttons.cancel") }}
      </v-btn>
      <v-btn
        :loading="isLoading"
        :disabled="isLoading"
        color="primary"
        @click="saveProductGroup"
      >
        {{ $t("productGroup.createProductGroupDescModal.buttons.save") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "createProductGroupDescModalComponent",
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    languages: {
      type: Array,
      required: true,
    },
    productDescription: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      availableLanguages: [],
      selectedLanguage: undefined,
      description: "",

      isLoading: false,
    };
  },
  mounted() {
    console.log(this.productDescription);
    this.setLanguage();
  },
  watch: {
    selectedLanguage() {
      this.setDescription();
    },
  },
  methods: {
    setLanguage() {
      this.availableLanguages = this.languages.map((item) => {
        return {
          languageCode: item.code2,
          title: /* this.$t(`languages.${item.code2}`) */ item.name,
          id: item.id,
        };
      });
      this.selectedLanguage = this.availableLanguages[0];
      this.availableLanguages.map((item) => {
        if (item.languageCode === "hu") {
          this.selectedLanguage = item.id;
        }
      });
      this.setDescription();
    },

    setDescription() {
      this.description = this.productDescription
        .filter((element) => element.id === this.id)
        .map((item) => item.product_group_description)
        .flat()
        .filter((item) => item.language.id === this.selectedLanguage)
        .map((item) => item.description);
    },

    saveProductGroup() {
      const datas = {
        message: this.description,
        id: this.id,
        lang: this.selectedLanguage,
      };
      this.$emit("saveProductGroup", datas);
    },

    closeModal() {
      if (document.activeElement.tagName != "INPUT") {
        this.$emit("closeModal");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.create-product-group-desc-modal {
  @media (max-width: 600px) {
    min-width: 320px;
  }
  min-width: 520px;
  padding: 24px;
  .button-row {
    display: flex;
    justify-content: space-between;
  }
  .message {
    ::v-deep .v-field__input {
      -webkit-mask-image: none !important;
      mask-image: none !important;
      border: 1px solid #a8a8a8;
      padding: 12px;
      border-radius: 5px;
    }
    ::v-deep .v-field__input:hover {
      border: 1px solid #000000de;
    }
    ::v-deep .v-field__input:focus {
      border: 2px solid #000000de;
      padding: 11px;
    }
  }
}
</style>
